import type { Client, RequestContext } from "../client";
import type { UserRoleResource } from "../resources/userRoleResource";
import { BasicRepository } from "./basicRepository";
export class UserRoleRepository extends BasicRepository<UserRoleResource, UserRoleResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("UserRoles", client, requestContext);
    }
}
